<div class="video-layout flex-1 min-h-0 relative h-full flex flex-col">
  <!-- Overlay kết nối không ổn định khi đang trong call video -->
  @if (
    callState() === CALL_STATE.CONNECTED &&
    (isShowMyNetworkReconnecting() || isShowRemoteNetworkWarning() || isShowMyNetworkWarning())
  ) {
    <div class="absolute inset-0 z-20 bg-black/30 flex items-center justify-center">
      <div class="flex flex-col items-center justify-center gap-4">
        <span class="animate-spin [animation-duration:2s]">
          <img
            src="./assets/icon/call/loading-icon.svg"
            alt="loading-icon"
            height="32"
            width="32"
          />
        </span>
        <p class="text-white text-center text-md typing px-5">
          {{
            isShowMyNetworkReconnecting()
              ? 'Đang kết nối lại'
              : 'Kết nối của ' +
                networkQualityInfoName() +
                ' không ổn định. Vui lòng chờ trong giây lát'
          }}
        </p>
      </div>
    </div>
  }
  <div
    class="video-container flex-1 min-h-0 relative px-4 pt-16"
    [class.is-pip]="isOpenPip()"
    [class.is-sharing]="isAnyScreenSharing()"
    [class.is-full-screen-share]="isFullScreenShare()"
  >
    <app-call-share-screen
      class="screen-wrapper block relative"
      [class.hidden]="!isAnyScreenSharing()"
      [isScreenSharing]="isScreenSharing()"
      [isRemoteSharing]="isRemoteSharing()"
      [isFullScreenShare]="isFullScreenShare()"
      [participant]="participant()"
      [sharingMicOn]="sharingMicOn()"
      [sharingSoundLevel]="sharingSoundLevel()"
      (stopShare)="stopShareEvt.emit()"
      (toggleFullScreen)="isFullScreenShare.set(!isFullScreenShare())"
    ></app-call-share-screen>

    <div class="video-list">
      <app-call-video-item
        class="video-item"
        [class.local-video]="!isAnyScreenSharing()"
        [data]="localVideoData()"
      ></app-call-video-item>
      <app-call-video-item
        class="video-item"
        [class.hidden]="isFullScreenShare()"
        [data]="remoteVideoData()"
      ></app-call-video-item>
    </div>
  </div>
  <div
    class="flex justify-between items-center px-4 pt-4"
    [class.hidden]="isFullscreen() && !isOpenPip()"
  >
    <span class="text-white font-medium text-xl">{{ callDuration() }}</span>
    <div class="flex items-center gap-1.5 flex-shrink-0">
      <app-icon name="call/lock-circle" [size]="20" svgClass="text-white" />
      <span class="text-white text-sm font-normal">Cuộc gọi mã hoá đầu cuối</span>
    </div>
  </div>
</div>
